export const consts ={
    VERSION: '0.0.3',
    BACKEND_ENPOINT: "http://localhost:3000",
    URL_PHOTO_AW3:"https://vixay-file.s3.ap-southeast-1.amazonaws.com/image-spa/",
    EXCHNAGE_ID:"65b2942c5e78b15103dee837",
    USER_KEY: 'USER_KEY_ADMIN',
    USER_NAME: 'USER_NAME',
    USER_PASSWORD: 'USER_PASSWORD',
    USER_REMEMBER: 'USER_REMEMBER',
    USER_TOKEN: 'USER_TOKEN_ADMIN',
    SECRET_KEY:'SECRET_KEY',
    USER_LOCATION: 'USER_LOCATION',

    //color theme
    COLOR_PRIMARY: '#007bff',
    COLOR_SECONDARY: '#6c757d',
    COLOR_SUCCESS: '#28a745',
    COLOR_DANGER: '#dc3545',
    COLOR_WARNING: '#ffc107',
    COLOR_INFO: '#17a2b8',
    COLOR_LIGHT: '#f8f9fa',
    COLOR_DARK: '#343a40',
    COLOR_BLACK: '#000000',
    COLOR_WHITE: '#ffffff',
    COLOR_GREY: '#868e96',
    COLOR_TRANSPARENT: 'transparent',
}

